import { AppState } from 'store';
import { MaintenanceMessageState } from './MaintenanceMessage.types';

export const maintenanceMessageSelector = ({
  maintenanceMessage,
}: AppState): MaintenanceMessageState => maintenanceMessage;
